import { styled } from '@mui/material/styles';

export const PageContainer = styled('div')({
	flex: '1 1 auto',
	display: 'flex',
	flexDirection: 'column',
});
